<template>
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
  >
    <div class="container-vue">
      <div>
        &copy; {{ year }}, made with <md-icon>favorite</md-icon> by WCC for a
        better PO experience.
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style>
.container-vue {
  display: flex;
  justify-content: center !important;
}
</style>
